import * as React from "react";
import { clamp01 } from "views/components/visualizations/OnClickPopover/anchors";
import SankeyOnClickPopover from "views/components/visualizations/OnClickPopover/SankeyOnClickPopover";
const isSankeyLinkPoint = (pt) => !Array.isArray(pt == null ? void 0 : pt.source) && !Array.isArray(pt == null ? void 0 : pt.target);
const getSankeyAnchorElement = (gd, pt) => {
  var _a, _b;
  const idx = (_a = pt.index) != null ? _a : pt.pointNumber;
  if (typeof idx !== "number") return null;
  const selector = isSankeyLinkPoint(pt) ? ".sankey-link" : ".sankey-node";
  const elements = gd.querySelectorAll(selector);
  return (_b = elements[idx]) != null ? _b : null;
};
const sankeyAnchorKey = (anchor) => {
  var _a, _b, _c;
  const pt = anchor.pt;
  const isLink = isSankeyLinkPoint(anchor.pt) || !!(pt.customdata && typeof pt.customdata === "object" && pt.customdata.source && pt.customdata.target);
  const curve = (_a = pt.curveNumber) != null ? _a : 0;
  const idx = (_c = (_b = pt.pointNumber) != null ? _b : pt.index) != null ? _c : 0;
  return `${curve}-${isLink ? "l" : "n"}-${idx}`;
};
const makeSankeyAnchor = (e, gd) => {
  var _a, _b, _c, _d, _e;
  const graphDiv = gd;
  const pt = (_a = e.points) == null ? void 0 : _a[0];
  if (!pt) return null;
  const domEvent = pt.originalEvent;
  const targetEl = (_b = domEvent == null ? void 0 : domEvent.target) != null ? _b : null;
  const el = (_e = (_d = (_c = targetEl == null ? void 0 : targetEl.closest) == null ? void 0 : _c.call(targetEl, ".sankey-link, .sankey-node")) != null ? _d : getSankeyAnchorElement(graphDiv, pt)) != null ? _e : graphDiv;
  const rect = el.getBoundingClientRect();
  const rel = domEvent ? {
    x: clamp01((domEvent.clientX - rect.left) / Math.max(rect.width, 1)),
    y: clamp01((domEvent.clientY - rect.top) / Math.max(rect.height, 1))
  } : { x: 0.5, y: 0.5 };
  return { el, pt, rel };
};
const renderPopover = ({ anchor, config, onPopoverClose }) => /* @__PURE__ */ React.createElement(
  SankeyOnClickPopover,
  {
    key: sankeyAnchorKey(anchor),
    clickPoint: anchor.pt,
    config,
    onPopoverClose
  }
);
const sankeyOnClickPopover = {
  buildAnchor: makeSankeyAnchor,
  renderPopover
};
export default sankeyOnClickPopover;
